// src/observations/store/actions/observations.actions.js
import { services } from '../../../../api/feathers';

export const GET_OBSERVATIONS = 'GET_OBSERVATIONS';
export const GET_OBSERVATION = 'GET_OBSERVATION';
export const ADD_OBSERVATION = 'ADD_OBSERVATION';
export const UPDATE_OBSERVATION = 'UPDATE_OBSERVATION';
export const REMOVE_OBSERVATION = 'REMOVE_OBSERVATION';

// lista todas as observations de um device
export function getObservations(deviceId) {
  return (dispatch) =>
    services.observations
      .find({
        query: {
          deviceId,
          $sort: { createdAt: 1 },
        },
      })
      .then((response) =>
        dispatch({ type: GET_OBSERVATIONS, payload: response.data })
      );
}

// busca uma única (se precisar)
export function getObservation(id) {
  return (dispatch) =>
    services.observations
      .get(id)
      .then((response) =>
        dispatch({ type: GET_OBSERVATION, payload: response })
      );
}

// cria e recarrega a lista
export function addObservation(obs) {
  return (dispatch) =>
    services.observations
      .create(obs)
      .then(() => dispatch(getObservations(obs.deviceId)));
}

// atualiza e recarrega a lista
export function updateObservation(id, obs) {
  return (dispatch) =>
    services.observations
      .patch(id, obs)
      .then((response) =>
        dispatch({ type: UPDATE_OBSERVATION, payload: response })
      )
      .then(() => dispatch(getObservations(obs.deviceId)));
}

// remove sem recarregar
export function removeObservation(id) {
  return (dispatch) =>
    services.observations
      .remove(id)
      .then((response) =>
        dispatch({ type: REMOVE_OBSERVATION, payload: response })
      );
}
